module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "side-nav"
  }, [_c('ul', _vm._l((_vm.data), function(item) {
    return _c('li', {
      staticClass: "nav-item"
    }, [(!item.path) ? _c('a', [_vm._v(_vm._s(item.name))]) : _c('router-link', {
      attrs: {
        "active-class": "active",
        "to": _vm.base + item.path,
        "exact": ""
      },
      domProps: {
        "textContent": _vm._s(item.title || item.name)
      }
    }), _vm._v(" "), (item.children) ? _c('ul', {
      staticClass: "pure-menu-list sub-nav"
    }, _vm._l((item.children), function(navItem) {
      return _c('li', {
        staticClass: "nav-item"
      }, [_c('router-link', {
        attrs: {
          "active-class": "active",
          "to": _vm.base + navItem.path
        },
        domProps: {
          "textContent": _vm._s(navItem.title || navItem.name)
        }
      })], 1)
    })) : _vm._e(), _vm._v(" "), (item.groups) ? _vm._l((item.groups), function(group) {
      return _c('div', {
        staticClass: "nav-group"
      }, [_c('div', {
        staticClass: "nav-group__title"
      }, [_vm._v(_vm._s(group.groupName))]), _vm._v(" "), _c('ul', {
        staticClass: "pure-menu-list"
      }, [_vm._l((group.list), function(navItem) {
        return [(!navItem.disabled) ? _c('li', {
          staticClass: "nav-item"
        }, [_c('router-link', {
          attrs: {
            "active-class": "active",
            "to": _vm.base + navItem.path
          },
          domProps: {
            "textContent": _vm._s(navItem.title)
          }
        })], 1) : _vm._e()]
      })], 2)])
    }) : _vm._e()], 2)
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1d152e3b!./~/vue-loader/lib/selector.js?type=template&index=0!./docs/components/side-nav.vue
// module id = 171
// module chunks = 3